export default "__VITE_ASSET__mm4gaLhg__"